import React from 'react';
import Dates from './Dates';

export default function SideBar() {
  return (
    <div style={container}>
      <Dates />
    </div>
  );
}

const container = {
  gridColumn: '2 / 1',
  background: '#252525',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  minHeight: '100vh',
};
